import { inject, Injectable } from '@angular/core';
import { SettingsService } from '@core/settings/settings.service';
import { SeoService } from '@targx/services/seo/seo.service';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ServicesSeoService extends SeoService {
  private settingsService = inject(SettingsService);

  setService(item: any) {
    this.emptyJsonSnippet();

    const seoItem = item?.data?.attributes.SEO;
    const seoSettings = this.settingsService.settings?.data?.attributes.SEO;

    if (!seoItem) {
      this.handleSeoFromApi(seoSettings);

      if (seoSettings?.metaImage) {
        this.setImage(
          `${environment.assets}${seoSettings?.metaImage?.data?.attributes.url}`,
        );
      }

      return;
    }

    this.handleSeoFromApi(seoItem);
    this.setUrl('services');

    if (seoItem?.metaImage) {
      this.setImage(
        `${environment.assets}${seoItem?.metaImage?.data?.attributes.url}`,
      );
    }

    // empty first
    this.emptyJsonSnippet();

    this.updateJsonSnippet({
      '@type': 'WebPage',
      '@id': seoItem.canonical,
      url: seoItem.canonical,
      name: seoItem.metaTitle,
      isPartOf: {
        '@id': 'https://motorbest.pt/#website',
      },
      datePublished: item?.data?.attributes.publishedAt,
      dateModified: item?.data?.attributes.updatedAt,
      description: seoItem.metaDescription,
      breadcrumb: {
        '@id': `${seoItem.canonical}/#breadcrumb`,
      },
      inLanguage: item?.data?.attributes.locale,
      potentialAction: [
        {
          '@type': 'ReadAction',
          target: [seoItem.canonical],
        },
      ],
    });

    // add a breadcrumb: Turtles > Turtle Rock
    this.updateJsonSnippet({
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Início',
          item: this.defaultUrl,
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'Serviços de comunicação',
        },
      ],
    });

    // add a breadcrumb: Turtles > Turtle Rock
    this.updateJsonSnippet({
      '@type': 'WebSite',
      '@id': 'https://motorbest.pt/#website',
      url: 'https://motorbest.pt/',
      name: seoSettings.metaTitle,
      description: seoSettings.metaDescription,
      potentialAction: [
        {
          '@type': 'SearchAction',
          target: {
            '@type': 'EntryPoint',
            urlTemplate: 'https://motorbest.pt/?s={search_term_string}',
          },
          'query-input': 'required name=search_term_string',
        },
      ],
      inLanguage: item?.data?.attributes.locale,
    });
  }
}
